<div class="container">
  <app-breadcrumb></app-breadcrumb>

  <div class="search-section" *ngIf="searchParams" [ngClass]="{'close-search-section': closeSearch}">
    <app-search-section [searchSide]="'worker'" [searchService]="searchWorkerService" [searchParams]="searchParams"
      (searching)="loadingStart()" (searchFinish)="loadingFinish()">
    </app-search-section>
  </div>

  <app-search-section-toggle [(closeStatus)]="closeSearch"></app-search-section-toggle>
  
  <div style="flex: auto;">
    <app-overview-list 
    [loading]="loading" 
    [pageNumber]="page" 
    [(openMailId)]="openMailId"
    [sharedAccountOffers]="sharedAccountOffers" 
    [offeredMailIds]="offeredMailIds"
    [readMails]="readMails"
    [mails]="workers" 
    [mailType]="'worker'" 
    [page]="listPage" 
    (loadNextPage)="onScroll()"
    (loadMailDetail)="loadMailDetail($event)"
    [(sortParams)]="sortParams"
    (sortParamsChange)="newSearch()"
    [searchParams]="searchParams"
    ></app-overview-list>
  </div>
</div>
<app-footer></app-footer>